import {
  getRequestConfig,
  GetRequestConfigParams,
  RequestConfig,
} from 'next-intl/server';

import { fetchSiteConfig } from '@/lib/api';

import type { NextRequest } from 'next/server';

export async function resolveRequestConfig({
  requestLocale,
}: GetRequestConfigParams): Promise<RequestConfig> {
  const { languages, default_language } = await fetchSiteConfig();
  const resolvedLocale = await requestLocale;

  const locale =
    languages.find(lang => lang.shortcode === resolvedLocale)?.shortcode ||
    default_language.shortcode;

  return {
    locale,
    now: new Date(),
    timeZone: 'UTC',
  };
}

export function getLocaleFromCookie(request: NextRequest): string | null {
  const localeCookie = request.cookies.get('NEXT_LOCALE')?.value;

  return localeCookie && validate(localeCookie)
    ? localeCookie.toLowerCase()
    : null;
}

export function getLocaleFromPath(pathname: string): string | null {
  const parts = pathname.split('/').filter(Boolean);
  const potentialLocale = parts[0];

  return validate(potentialLocale) ? potentialLocale : null;
}

function validate(locale: string): boolean {
  return /^([a-z]{2,4})$/i.test(locale);
}

export default getRequestConfig(resolveRequestConfig);
